export default "__VITE_ASSET__BC5nG4jQ__"